module.exports = __webpack_public_path__ + "static/img/bg3.f0a2f2f9.png";